import React, { useEffect, useState, useContext, useRef } from "react";
import { Store } from "@store";
import styles from "@styles/profile/joinedCommunitiesTab.module.css";
import { useRouter } from "next/router";
import { getJoinedCommunities } from "@queries/user.queries";
import { viewCommunityProfile } from "@utils/viewPage";
import { Search as SearchIcon } from "@mui/icons-material";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingCircle from "@components/loadings/LoadingCircle";
import Heading from "@components/general/Heading";
import axios from "../../utilities/api/axiosInstance";
import CommunityProfileItem from "@components/general/CommunityProfileItem";
import style from "@styles/profile/profile.module.css";
import { Divider } from "@mui/material";
export default function JoinedCommunitiesTab({
  uid
}) {
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const router = useRouter();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [foundCommunities, setFoundCommunities] = useState(null);
  const [pageNo, setPageNo] = useState(0);
  const REF = useRef(null);
  async function getQueryCommunities({
    searchInput,
    page
  }) {
    let link;
    if (page) {
      link = `user/searchjoincommunity?query=${searchInput}&uid=${uid}&page=${page}`;
    } else {
      link = `user/searchjoincommunity?query=${searchInput}&uid=${uid}`;
    }
    let data = null;
    let error = null;
    const requestOptions = {
      method: "GET",
      url: encodeURI(link)
    };
    const response = await axios(requestOptions).catch(err => {
      error = err;
    });
    if (response?.data?.success) {
      data = response.data?.response;
    }

    // if (response?.data?.success) hashtags = response?.data?.response;
    // else if (response?.data?.message) error = response.data.message;
    return {
      data,
      error
    };
  }
  const updateFoundCommunities = async () => {
    let {
      data,
      error
    } = await getQueryCommunities({
      searchInput: searchText,
      page: pageNo + 1
    });
    if (!error && data) {
      setPageNo(cur => cur + 1);
      if (data.length !== 0) {
        setFoundCommunities(currentData => currentData?.concat(data));
      }
    }
  };
  useEffect(() => {
    setPageNo(0);
    setFoundCommunities(null);
    async function getSearchedMembers() {
      let {
        data,
        error
      } = await getQueryCommunities({
        searchInput: searchText
      });
      if (data) setFoundCommunities(data);
    }
    if (searchText) {
      getSearchedMembers();
    } else {}
  }, [searchText]);
  useEffect(() => {
    setTimeout(() => {}, 2000);
  }, [foundCommunities]);
  useEffect(() => {
    async function getData(token) {
      const response = await getJoinedCommunities({
        accessToken: loggedInUser.accessToken,
        uid: uid,
        cancelToken: token
      });
      if (response) {
        setData(response);
      } else {
        setData([]);
      }
      setIsLoading(false);
    }

    // let source = null;
    // if (loggedInUser.loginType !== "guest") {
    //   source = axios.CancelToken.source();
    //   getData(source.token);
    // }
    getData();

    // return () => {
    //   if (source) source.cancel();
    // };
  }, [loggedInUser, uid]);
  useEffect(() => {
    if (typeof window !== "undefined" && REF.current && !isLoading) {
      if (REF.current.clientHeight <= window.innerHeight && data.length <= 10) {
        updateCommunityData();
      }
    }

    // eslint-disable-next-line
  }, [REF, isLoading]);
  async function updateCommunityData() {
    let ts = null;
    if (data?.length > 0) ts = data[data.length - 1].joiningTime;else return () => {};
    const res = await getJoinedCommunities({
      accessToken: loggedInUser.accessToken,
      uid: uid,
      ts
    });
    if (res?.length === 0) {
      setHasMore(false);
    } else setData(cur => cur.concat(res));
  }
  function renderCommunity(item, index) {
    return <div key={index.toString()} data-sentry-component="renderCommunity" data-sentry-source-file="JoinedCommunitiesTab.jsx">
        <CommunityProfileItem data={item} onClickHandler={() => viewCommunityProfile(item.urlExtension, router)} data-sentry-element="CommunityProfileItem" data-sentry-source-file="JoinedCommunitiesTab.jsx" />
        {/* <hr className={styles.joinedCommunitiesHr} /> */}
        <Divider sx={{
        opacity: 0.5
      }} data-sentry-element="Divider" data-sentry-source-file="JoinedCommunitiesTab.jsx" />
      </div>;
  }
  if (isLoading) {
    return <p className={styles.loadingText}>Loading...</p>;
  } else {
    return <>
        {data?.length > 0 && <div>
            <Heading headline={"Joined Communities"} />

            <div className={styles.searchContainer}>
              <div className={styles.search_container}>
                <input type="text" placeholder="Search..." onChange={e => {
              setSearchText(e.target.value);
            }} />
                <div className={styles.search_Icon}>
                  <SearchIcon />
                </div>
              </div>
            </div>

            {searchText === "" && <div className={styles.community_list_container} ref={REF}>
                <InfiniteScroll dataLength={data.length} next={updateCommunityData} hasMore={hasMore} loader={<LoadingCircle />}>
                  {data.map(renderCommunity)}
                </InfiniteScroll>
              </div>}

            {foundCommunities?.length === 0 && <div>
                <p style={{
            textAlign: "center"
          }}>
                  <b>No Communities Found</b>
                </p>
              </div>}

            {searchText !== "" && foundCommunities && <div className={styles.foundCommunities_container} ref={REF}>
                <InfiniteScroll dataLength={foundCommunities?.length} next={updateFoundCommunities} hasMore={true} loader={<LoadingCircle />}
          // endMessage={
          //   <p style={{textAlign: 'center'}}>
          //     <b>Yay! You have seen it all</b>
          //   </p>
          // }
          scrollableTarget={style.profile_display_inner_right} endMessage={<p style={{
            textAlign: "center",
            marginTop: "100px",
            zIindex: "100"
          }}>
                      <b>Yay! You have seen it all</b>
                    </p>}>
                  {foundCommunities.map(renderCommunity)}
                </InfiniteScroll>
              </div>}
          </div>}
      </>;
  }
}